type ClassDictionary = Record<string, boolean | undefined | null>;

export function classNames(classes: ClassDictionary): string {
  return Object.entries(classes)
    .filter(([_, value]) => Boolean(value))
    .map(([key]) => key)
    .join(" ");
}
